import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import User from 'flarum/common/models/User';
app.initializers.add('val-ui-highest-rank-badge', () => {
  extend(User.prototype, 'badges', function (items) {
    const groups = this.groups ? this.groups() || [] : [];
    const ids = new Set(groups.map(group => Number(group.id())));

    /*
     * Hiérarchie des rangs VAL :
     *
     * 5     Membre d'honneur
     * 6 / 9 Membre régulier
     * 7 / 8 Membre débutant
     * 3     Member
     *
     * Les autres groupes (admin, modération, etc.) ne sont pas touchés.
     */
    const levels = [[5], [6, 9], [7, 8], [3]];
    const activeLevel = levels.find(level => level.some(id => ids.has(id)));
    if (!activeLevel) return;

    // S'il existe deux variantes du même rang, priorité au groupe automatique.
    const keepId = activeLevel.find(id => ids.has(id));
    [3, 5, 6, 7, 8, 9].forEach(id => {
      if (id !== keepId) {
        items.remove(`group${id}`);
      }
    });
  });
});